<ngx-mat-color-palette
  (colorChanged)="picker.select($event)"
  [color]="picker._selected"
></ngx-mat-color-palette>
